import { get, post } from "../config/api/user";

export const User = {
  getSelf: () => get(`user/self`),
};
